import { Component, OnInit } from '@angular/core';
import { ValidationError, FormValidationService, AlertService, ErrorHandlingService, FormValidator } from 'core-lib';
import { environment } from '../../environments/environment';
import { PermitDetailsModel, PermitService } from '../services/permit.service';

@Component({
  selector: 'cli-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  public vm: ContactUsViewModel;
  private validator: FormValidator;

  constructor(private permitSvc: PermitService,
    private errorHandlingSvc: ErrorHandlingService,
    private alertSvc: AlertService,
    private formValidationSvc: FormValidationService) {

    this.vm = new ContactUsViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);
  }

  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitSvc.model;

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.mapModel(this.vm, data);

      this.vm.isLoading = false;
      this.vm.isOpening = false;
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });
  }

  mapModel(vm: ContactUsViewModel, data: PermitDetailsModel) {
    vm.businessName = data.permitDetails.clientName;
    vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName;
    vm.permitNo = data.permitDetails.permitNo;
  }

  public sendEmail(): Promise<void> {

   
    return this.validate(this.vm).then(() => {

      this.vm.isLoading = true;

      return this.permitSvc.sendEmailToAdmin(this.vm.subject, this.vm.message).toPromise()
        .then(() => {

          this.alertSvc.success(environment.TOASTR_HEADER, 'A notification was successfully sent to the admin team', 2000, true);
          this.vm.subject = '';
          this.vm.message = '';

        },
          (e) => { this.errorHandlingSvc.processHttpError(e); }).finally(() => {
            this.vm.isLoading = false;
          })

    },
      (e) => { });

  }

  validate(vm: ContactUsViewModel): Promise<void> {
    this.vm.errors = [];

    this.validator.validateRequired('subject', 'Subject');
    this.validator.validateRequired('message', 'Message');

    this.validator.validateMaxLength('subject', 'Subject', 100);
    this.validator.validateMaxLength('message', 'Message', 4000);

    if (this.vm.errors.length > 0) { 
      return Promise.reject('Invalid input'); }

    return Promise.resolve();
  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

}

export class ContactUsViewModel{
  constructor() {
    this.errors = [];
  }

  public isOpening: boolean;
  public isLoading: boolean;
  public businessName: string;
  public contactName: string;
  public permitNo: string;

  public subject: string;
  public message: string;

  public errors: ValidationError[];
}